module.exports = __webpack_public_path__ + "img/mobile-36.296cf5a4.png";